module.exports = __webpack_public_path__ + "img/line-chart-spline-dark-01.cab52f0c.jpg";